import { LANGUAGES } from '../constants/languages';

// Some API fields are a string, others are { ru, en }.
const getLocalizedText = (value, lang) => {
  if (value == null || typeof value === 'number' || typeof value === 'boolean') return value ?? '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    return value[lang] || value[LANGUAGES.ru.code] || value[LANGUAGES.en.code] || '';
  }
  return '';
};

export default getLocalizedText;
